import { render } from "./UserPasswordReset.vue?vue&type=template&id=5143f697"
import script from "./UserPasswordReset.vue?vue&type=script&lang=js"
export * from "./UserPasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__